import styled, { keyframes } from "styled-components";

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
`;

export const AuditContainer = styled.div`
  background-color: #f4f6f9;
  min-height: 100vh;
  padding: 20px;
  animation: ${fadeIn} 0.5s ease-out;

  @media (min-width: 768px) {
    padding: 40px;
  }
`;

export const Header = styled.h1`
  color: #2c3e50;
  font-size: 2.2rem;
  font-weight: 600;
  margin-bottom: 30px;
`;

export const Card = styled.div`
  background-color: #ffffff;
  border-radius: 8px;
  border: 1px solid #eaecef;
  padding: 25px 30px;
  margin-bottom: 30px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  transition: box-shadow 0.3s ease;

  &:hover {
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);
  }
`;

export const CardHeader = styled.h2`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 0;
  margin-bottom: 25px;
  color: #34495e;
  font-size: 1.4rem;
  font-weight: 500;
  border-bottom: 1px solid #eaecef;
  padding-bottom: 15px;
`;

export const FilterContainer = styled.form`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 20px;
  align-items: flex-end;
`;

export const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  label {
    font-size: 0.8rem;
    font-weight: 600;
    color: #6c757d;
    text-transform: uppercase;
  }

  input {
    height: 42px;
    font-size: 1rem;
    padding: 0 15px;
    background-color: #f8f9fa;
    border: 1px solid #ced4da;
    border-radius: 6px;
    color: #212529;
    transition: all 0.2s ease-in-out;

    &:focus {
      outline: none;
      border-color: #b17d2a;
      box-shadow: 0 0 0 3px rgba(177, 125, 42, 0.15);
    }
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  gap: 10px;
  padding-bottom: 1px;
`;

export const ActionButton = styled.button`
  height: 42px;
  flex-grow: 1;
  cursor: pointer;
  border-radius: 6px;
  font-size: 0.9rem;
  font-weight: 700;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  background-color: #b17d2a;
  color: #ffffff;
  border: 1px solid #b17d2a;

  ${(props) =>
    props.secondary &&
    `
    background-color: transparent;
    color: #6c757d;
    border: 1px solid #ced4da;

    &:hover {
      background-color: #f8f9fa;
      border-color: #adb5bd;
    }
  `}

  &:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  }
`;

export const TableContainer = styled.div`
  overflow-x: auto;
  margin-top: 30px;
`;

export const AuditTable = styled.table`
  width: 100%;
  border-collapse: collapse;

  th,
  td {
    padding: 16px;
    text-align: left;
    border-bottom: 1px solid #eaecef;
    vertical-align: middle;
  }

  th {
    background-color: #f8f9fa;
    color: #6c757d;
    font-weight: 600;
    text-transform: uppercase;
    font-size: 0.75rem;
    letter-spacing: 0.5px;
  }

  td {
    color: #212529;
  }

  tr:last-child td {
    border-bottom: none;
  }
`;

export const PaginationContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;
  margin-top: 30px;

  span {
    font-size: 1rem;
    font-weight: 500;
    color: #6c757d;
  }
`;

export const PageButton = styled(ActionButton)`
  height: 40px;
  padding: 0 20px;

  &:disabled {
    background-color: #e9ecef;
    color: #adb5bd;
    border-color: #dee2e6;
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
  }
`;

// --- NOVOS ESTILOS PARA O SELETOR (TOGGLE) ---

export const ToggleContainer = styled.div`
  display: flex;
  background-color: #e9ecef;
  padding: 4px;
  border-radius: 8px;
  width: fit-content;
  margin-bottom: 20px;
`;

export const ToggleButton = styled.button`
  padding: 8px 24px;
  border: none;
  border-radius: 6px;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;

  background-color: ${(props) => (props.active ? "#b17d2a" : "transparent")};
  color: ${(props) => (props.active ? "#ffffff" : "#6c757d")};
  box-shadow: ${(props) =>
    props.active ? "0 2px 6px rgba(0,0,0,0.1)" : "none"};

  &:hover {
    color: ${(props) => (props.active ? "#ffffff" : "#2c3e50")};
  }
`;
